import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { CoreService } from './core/services/core.service';
import { Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Cars2click-Supplier';

  constructor(private msalService: MsalService,
    private coreService: CoreService,
    private router: Router,
    private authService: AuthService) {

    this.msalService.handleRedirectObservable().subscribe((resp: AuthenticationResult) => {
      if (resp) {
        if (this.msalService.instance.getAllAccounts().length > 0) {
          let account = this.msalService.instance.getAllAccounts();

          this.msalService.instance.setActiveAccount(account[0]);
        }

        localStorage.setItem('msalToken', resp.idToken);

        setTimeout(() => {
          this.coreService.checkIfUserInfo().then(resp => {
            if (resp.sellerCompany && resp.role === 'CLIENT') {
              if (localStorage.getItem('redirectURL')) {
                let redirect = localStorage.getItem('redirectURL');

                localStorage.removeItem('redirectURL');

                this.router.navigate([redirect]);
              } else {
                this.router.navigate(['home']);
              }
            } else {
              this.router.navigate(['restricted']);
            }
          });
        }, 1000);
      } else if (this.msalService.instance.getActiveAccount()) {
        this.authService.isLoggedInRedirect.next(true);
      }
    });
  }
}
